const FEATURE_FLAGS = {
  IS_GRID_VIEW_ENABLED: 'feature.web5.grid.view',
  IS_OMP_USER: 'feature.core.traderev.omp.integration.enabled',
  IS_MIN_BID_QUICK_BID_ENABLED: 'feature.core.minimum.bid.quick.bid',
  IS_TIAH_WHITE_LABEL_ENABLED: 'feature.core.tiah.white.label',
  SHOULD_REDIRECT_USER_TO_OMP: 'feature.user.redirect.to.omp',
  IS_USER_HARD_MIGRATED_OMP: 'feature.core.user.omp.hard.migrated',
  IS_REMOVE_OPEN_TO_DGN_ENABLED: 'feature.core.remove.open.to.dgn'
};

export default FEATURE_FLAGS;
